import { render } from "./DriverCard.vue?vue&type=template&id=2d262545&scoped=true"
import script from "./DriverCard.vue?vue&type=script&lang=js"
export * from "./DriverCard.vue?vue&type=script&lang=js"

import "./DriverCard.vue?vue&type=style&index=0&id=2d262545&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d262545"]])

export default __exports__